import script from "./EmployeeReviewModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmployeeReviewModal.vue?vue&type=script&setup=true&lang=ts"

import "./EmployeeReviewModal.vue?vue&type=style&index=0&id=3a736d48&lang=scss"
import "./EmployeeReviewModal.vue?vue&type=style&index=1&id=3a736d48&scoped=true&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a736d48"]])

export default __exports__